import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import type {LinkVariant} from 'shells/link/types';

interface Props {
    onClose: () => void;
    variant?: LinkVariant;
    label?: string;
}

export function ManagePlanLink(props: Props) {
    const {variant = 'button-primary', label = 'Manage your plan'} = props;

    return (
        <Link
            // @ts-expect-error
            as={RoutedLink}
            size='big'
            variant={variant}
            to='/setup/billing/sales'
            onClick={props.onClose}
        >
            {label}
        </Link>
    );
}
